import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../configs/config.common';
import { ShowingBookFormatter } from './showing.book.formatter';
import { ShowingBookValidator } from './showing.book.validator';
import { AxiosPromise } from '../../../src/utils/axios.promise';
import moment from 'moment';
import { ILeadCreateForm, getSourceChannel, createLead } from '../../utils/lead.manager';
@Component
export default class WwwShowingBook extends Vue {
   @Prop()
   public identifier: any;
   public title: string = 'WwwShowingBook';
   public agentName: string = '';
   public isShowList: boolean = false;
   public isShowForm: boolean = false;
   public phoneE164: string = '';
   public phone: string = '(416)883-9666';
   public bottomOffset = '0px;';
   public bottom = 0;
   public formatter = new ShowingBookFormatter();
   public config = new CommonConfig();
   public regionCode = '+1';
   public regionCodes: any[] = [
      { value: '+1', text: '+1' },
      // { value: '+86', text: '+86' },
   ];
   public fields: any = {
      name: {
         value: '',
         state: null,
      },
      remark: {
         value: '',
         state: null
      },
      phone: {
         value: '',
         state: null
      },
      email: {
         value: '',
         state: null
      }
   };
   public resetModal() {
      this.fields = {
         name: {
            value: '',
            state: null,
         },
         remark: {
            value: '',
            state: null
         },
         phone: {
            value: '',
            state: null
         },
         email: {
            value: '',
            state: null
         }
      };
   }
   public agentList: any = [];
   public async created() {
      const apiHost = this.config.houseRecommendService;
      const houseId = this.identifier;
      const dataFetched = await AxiosPromise.get(`${apiHost}/getAgentInfosByHouseId?houId=${houseId}`);
      if (dataFetched.code === 200) {
         this.agentList = dataFetched.data;
      }
   }
   public hideAgentList() {
      this.isShowList = false;
   }
   public hideContactForm() {
      this.isShowForm = false;
   }
   public mobileHook() {
      if (this.agentList.length === 0) {
         this.isShowForm = true;
      } else {
         this.isShowList = true;
      }
   }
   public async handleOk(evt: any) {
      evt.preventDefault();
      this.$store.commit('appStartFetching');
      const result = await this.handleSubmit();
      this.$store.commit('appEndFetching');
      if (result) {
         this.resetModal();
         this.hideContactForm();
      }
   }
   public async handleSubmit() {
      const message = `Property Identifier: ${this.identifier};
            Remarks: ${this.fields.remark.value}
            Message from Rifo Epic Web.`;
      const validateResult = ShowingBookValidator.validator(this.fields);
      const apiHost = this.config.cmisapiHost;
      if (!validateResult) {
         const leadForm: ILeadCreateForm = {
            leadName: 'Lead From EpicWeb',
            clientName: this.fields.name.value,
            email: this.fields.email.value,
            phone: `${this.fields.phone.value}`,
            registerAccount: false,
            channel: getSourceChannel(this.$i18n.locale),
            clientMsg: message
         };
         const result = await createLead(leadForm);
         this.$Notice.success({
            title: 'Appointment Done',
            desc: 'The agent will be contacting you soon.'
         });
         return true;
      } else {
         this.$Notice.error({
            title: validateResult,
            // desc: 'The agent will be contacting you soon.'
         });
         //    alert();
         return false;
      }
   }
}
